import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { register } from '../api';
import { setToken, setUser } from '../storage';

export default function Register() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const r = await register(email, password, name);
      setToken(r.token);
      setUser({ id: r.user.id, email: r.user.email });
      navigate('/');
    } catch (e: any) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="auth">
      <h1>记住</h1>
      <h2>注册</h2>
      <form onSubmit={submit}>
        <input type="email" placeholder="邮箱" value={email} onChange={e => setEmail(e.target.value)} required />
        <input type="password" placeholder="密码 (≥ 8 位)" value={password} onChange={e => setPassword(e.target.value)} required minLength={8} />
        <input type="text" placeholder="显示名" value={name} onChange={e => setName(e.target.value)} required />
        {error && <div className="error">{error}</div>}
        <button type="submit" disabled={loading}>{loading ? '注册中…' : '注册'}</button>
        <Link to="/login">已有账号?登录</Link>
      </form>
    </div>
  );
}
